import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { NavigationComponent } from './components/navigation/navigation.component';
import { SharedModule } from '../shared/shared.module';

import { NAVIGATION_ELEMENTS, NAVIGATION_ENTRY_ELEMENTS } from "./elements";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    ...NAVIGATION_ELEMENTS,
    NavigationComponent
  ],
  entryComponents: [
    ...NAVIGATION_ENTRY_ELEMENTS
  ],
  exports: [
    ...NAVIGATION_ELEMENTS,
    NavigationComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class NavigationModule { }
